import React, { useState, useEffect, useCallback } from "react";
import Modal from "../DynamicComp/modal";
import Input from "../DynamicComp/Input";
import Button from "../DynamicComp/Button";
import { IoEyeOffOutline, IoEyeOutline } from "react-icons/io5";
import { getData, postData,GOOGLE_CLIENT_ID } from "../../global/Globalapi";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
import { jwtDecode } from "jwt-decode";
// import { useEffect, useCallback } from "react";
import { handleApiError } from "../../global/Globalfunction";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";


const LoginModal = ({ isModalOpen, setIsModalOpen, setSignUp, setUser, type }) => {
  const [email, setEmail] = useState("");
  const [userpassword, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
const navigate = useNavigate();
  // Handle regular login
  const handleLogin = async (e) => {
    e.preventDefault();
    localStorage.removeItem("user");
    setUser(null);
    try {
      const response = await postData("/check_username", { email, userpassword });
      const user = response.data.user;
      localStorage.setItem("user", JSON.stringify(user));
      setUser(user);
      setIsModalOpen(false);
    } catch (error) {
      console.error("Login error:", error);
      swal(error.response?.data?.message || "Login failed");
    }
  };

  // Handle guest login
  const handleguest = async (e) => {
    e.preventDefault();

    try {
      const res = await getData("/session/init");

      console.log("Guest login response:", res);

      if (res?.status === 200 && res?.data?.user) {
        const guestData = res.data.user;

        localStorage.setItem("user", JSON.stringify(guestData));
        setUser(guestData);

        // swal("Logged in as Guest");
        setIsModalOpen(false);

        console.log("Guest data saved:", guestData);
      } else {
        swal("Guest login failed");
      }
    } catch (error) {
      console.error("Guest login error:", error);
     swal("Failed to login as guest");
    }
  };

  // Handle Google Sign-in callback
  // const handleCredentialResponse = useCallback(async (response) => {
  //   try {
  //     const userObject = jwtDecode(response.credential);

  //     // Post to backend
  //     const backendRes = await postData("/add_google_user", {
  //       name: userObject.name,
  //       email: userObject.email,
  //       phone: userObject.phone_number || "1111111111",
  //       username: userObject.email,
  //       password: "google-auth",
  //       user_type: "Google User",
  //       status: "Active",
  //     });

  //     if (backendRes?.data?.user) {
  //       const user = backendRes.data.user;
  //       localStorage.setItem("user", JSON.stringify(user));
  //       setUser(user);
  //       setIsModalOpen(false);
  //       toast.success("Signed in with Google successfully!");
  //     } else {
  //       localStorage.setItem("user", JSON.stringify(userObject));
  //       setUser(userObject);
  //       setIsModalOpen(false);
  //       toast.success("Signed in with Google!");
  //     }
  //   } catch (error) {
  //     console.error("Google Sign-In Error:", error);
  //     toast.error("Failed to sign in with Google.");
  //   }
  // }, [setUser, setIsModalOpen]);
// const handleCredentialResponse = useCallback(async (response) => {
//   try {
//     const userObject = jwtDecode(response.credential);

//     await postData("/add_google_user", {
//       name: userObject.name,
//       email: userObject.email,
//       phone: userObject.phone_number || "1111111111",
//       username: userObject.email,
//       password: "google-auth",
//       user_type: "Google User", // ✅ ADD THIS
//       status: "active"          // ✅ LOWERCASE
//     });

//     toast.success("Signed in with Google");
//   } catch (error) {
//     console.error("Google Sign-In Error:", error);
//     toast.error("Google sign-in failed");
//   }
// }, []);
const handleCredentialResponse = useCallback(async (response) => {
  try {
    const userObject = jwtDecode(response.credential);

    const backendRes = await postData("/add_google_user", {
      name: userObject.name,
      email: userObject.email,
      phone: userObject.phone_number || "1111111111",
      username: userObject.email,
      password: "google-auth",
      user_type: "Google User",
      status: "active",
    });

    // const user = backendRes?.data?.user;

    // if (!user) {
    //   throw new Error("User data not returned");
    // }

    // // ✅ STORE LOGIN STATE
    // localStorage.setItem("user", JSON.stringify(user));
    // setUser(user);
    // setIsModalOpen(false);
const backendUser = backendRes?.data?.user;

if (!backendUser) {
  throw new Error("User data not returned");
}

const finalUser = {
  ...backendUser,
  name: userObject.name,
  email: userObject.email,
  picture: userObject.picture,
};

console.log("Google decoded user:", userObject);
console.log("Final saved user:", finalUser);

localStorage.setItem("user", JSON.stringify(finalUser));
setUser(finalUser);
setIsModalOpen(false);
    // swal("Signed in with Google successfully 🎉");
  } catch (error) {
    // console.error("Google Sign-In Error:", error);
    // toast.error("Failed to sign in with Google");
    console.error("Google Sign-In Error:", error);
console.log("STATUS:", error?.response?.status);
console.log("MESSAGE:", error?.response?.data);

  handleApiError(error, {
    closePopup: true,
    onClose: () => setIsModalOpen(false),
  });
  }
}, [setUser, setIsModalOpen]);

  // Initialize Google Sign-in when modal opens
  useEffect(() => {
    const buttonElement = document.getElementById("google-signin-button");

    if (isModalOpen && window.google && buttonElement) {
      // Initialize with the callback function
      window.google.accounts.id.initialize({
         client_id: GOOGLE_CLIENT_ID,
        callback: handleCredentialResponse,
      });

      // Render the button
      // window.google.accounts.id.renderButton(
      //   buttonElement,
      //   { theme: "outline", size: "large", width: 320% }
      // );
      window.google.accounts.id.renderButton(
  document.getElementById("google-signin-button"),
  {
    theme: "outline",
    size: "large",
    width: 320,
  }
);

      buttonElement.style.display = 'block';
    } else if (!isModalOpen && window.google && buttonElement) {
      // Cleanup when modal closes
      buttonElement.innerHTML = "";
      buttonElement.style.display = 'none';
      window.google.accounts.id.cancel();
    }
  }, [isModalOpen, handleCredentialResponse]);

  return (
    <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} title="Sign in">
      <div>
        <div className="mb-4">
          <Input
            type="email"
            value={email}
            placeholder="Email"
            onChange={(e) => setEmail(e.target.value)}
            className="w-full p-3 border rounded-lg outline-none focus:ring-1 focus:ring-black"
          />
        </div>
        <div className="mb-2 relative">
          <Input
            type={showPassword ? "text" : "password"}
            placeholder="Password"
            value={userpassword}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full p-3 border rounded-lg outline-none focus:ring-1 focus:ring-black"
          />
          {/* <Button
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 bg-transparent p-0 border-none shadow-none hover:bg-transparent focus:ring-0"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? <IoEyeOutline size={20} /> : <IoEyeOffOutline size={20} />}
          </Button> */}
          <button
  type="button"
  className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 bg-transparent border-none outline-none cursor-pointer"
  onClick={() => setShowPassword(!showPassword)}
>
  {showPassword ? <IoEyeOutline size={20} /> : <IoEyeOffOutline size={20} />}
</button>
        </div>
        {/* <p className="text-red-600 text-right text-sm mb-4 cursor-pointer hover:underline">
          Forgot Password?
        </p> */}
     <p
  className="text-red-600 mt-2 mb-2 text-right text-sm cursor-pointer"
  onClick={() => {
    setIsModalOpen(false);
    navigate("/forgot-password");
  }}
>
  Forgot Password?
</p>

        <Button
          // variant="gray"
          className="w-full text-white p-3 rounded-lg text-lg font-semibold "
          onClick={handleLogin}
        >
          Continue
        </Button>

        {type !== "guest" && (
          <Button
            // variant="gray"
            className="w-full  text-white mt-1 p-3 rounded-lg text-lg font-semibold "
            onClick={handleguest}
          >
            Continue as Guest
          </Button>
        )}

        <div className="flex items-center my-4">
          <hr className="flex-grow border-black" />
          <span className="mx-1 text-gray-700 text-sm">Or</span>
          <hr className="flex-grow border-black" />
        </div>

        {/* <div id="google-signin-button" className="w-full flex items-center justify-center"></div> */}
        <div className="flex justify-center w-full">
  <div id="google-signin-button" className="max-w-[320px] w-full"></div>
</div>


        <p className="text-center text-gray-600 mt-4">
          Not registered yet?{" "}
          <span
            className="text-blue-600 hover:underline cursor-pointer"
            onClick={() => {
              setSignUp(true);
              setIsModalOpen(false);
            }}
          >
            Create an account
          </span>
        </p>
      </div>
    </Modal>
  );
};

export default LoginModal;